export default function ErrorOnLoad() {
  return (
    <div
      className="container text-center d-flex align-items-center justify-content-center flex-column"
      style={{ height: "100vh" }}
    >
      <h1>We cannot load the current requested site</h1>
      <p>Please, let the studio know about this issue</p>
      <button
        className="btn btn-primary btn-lg"
        onClick={() => (window.location.href = "/")}
      >
        Back to Home
      </button>
    </div>
  );
}
